<!-- <p>add-user-dialog works!</p> -->
<div *ngIf="data.isAdd">
  <h1 mat-dialog-title>Adding New User</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <i>Please wait while adding new user!</i>
      <mat-spinner></mat-spinner>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
</div>

<div *ngIf="data.isRemove">
  <h1 mat-dialog-title>Removing User</h1>
  <mat-dialog-content class="mat-typography">
    <!-- {{ data | json }} -->
    <div class="add-user-dialog-status">
      <i>Please wait while removing user!</i>
      <mat-spinner></mat-spinner>
    </div>

    <mat-divider></mat-divider>
  </mat-dialog-content>
</div>
